// frontend/src/components/CrearPartidaModal.jsx
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import presupuestosService from '../services/presupuestosService';
import './CrearModal.css';

const CrearPartidaModal = ({ areaId, onClose, onPartidaAdded }) => {
  const [tab, setTab] = useState('crear');
  const [formData, setFormData] = useState({
    nombre_partida: '',
    descripcion: '',
    cantidad: '',
    valor_unitario: '',
    unidad: 'unidad',
    status: 'activo'
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre_partida.trim()) {
      toast.error('El nombre de la partida es requerido');
      return;
    }

    // Los datos se envían con los valores que el usuario ingresó
    onPartidaAdded({
      ...formData,
      cantidad: parseFloat(formData.cantidad) || 0,
      valor_unitario: parseFloat(formData.valor_unitario) || 0
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="crear-modal-overlay" onClick={onClose}>
      <div className="crear-modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>➕ Crear Partida</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label>Nombre de la Partida *</label>
            <input
              type="text"
              name="nombre_partida"
              value={formData.nombre_partida}
              onChange={handleChange}
              placeholder="Ej: Desarrollo Frontend, Diseño UI, etc."
              required
            />
          </div>

          <div className="form-group">
            <label>Descripción</label>
            <textarea
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Descripción de la partida..."
              rows={2}
            ></textarea>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Cantidad</label>
              <input
                type="number"
                name="cantidad"
                value={formData.cantidad}
                onChange={handleChange}
                min="0"
                step="0.01"
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>Valor Unitario</label>
              <input
                type="number"
                name="valor_unitario"
                value={formData.valor_unitario}
                onChange={handleChange}
                min="0"
                step="0.01"
                placeholder="0"
              />
            </div>

            <div className="form-group">
              <label>Unidad</label>
              <select
                name="unidad"
                value={formData.unidad}
                onChange={handleChange}
              >
                <option value="unidad">Unidad</option>
                <option value="hora">Hora</option>
                <option value="día">Día</option>
                <option value="mes">Mes</option>
                <option value="kg">kg</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="activo">Activo</option>
              <option value="inactivo">Inactivo</option>
            </select>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Crear Partida
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CrearPartidaModal;
